import { render, staticRenderFns } from "./EditModal.vue?vue&type=template&id=c37589c2&scoped=true"
import script from "./EditModal.vue?vue&type=script&lang=js"
export * from "./EditModal.vue?vue&type=script&lang=js"
import style0 from "./EditModal.vue?vue&type=style&index=0&id=c37589c2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37589c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data0/web/xyadmin.98du.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c37589c2')) {
      api.createRecord('c37589c2', component.options)
    } else {
      api.reload('c37589c2', component.options)
    }
    module.hot.accept("./EditModal.vue?vue&type=template&id=c37589c2&scoped=true", function () {
      api.rerender('c37589c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/productAppConfig/productConfig/projectManage/components/EditModal.vue"
export default component.exports